var React = require('react');

function Listen (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"6","cy":"18","r":"3","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("circle",{"cx":"18","cy":"18","r":"3","stroke":"currentColor","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M21 18V4C21 3.44772 20.5523 3 20 3H10C9.44772 3 9 3.44772 9 4V18","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","key":2}),React.createElement("path",{"d":"M10 8H21","stroke":"currentColor","strokeWidth":"2","key":3})]);
}

Listen.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Listen;

Listen.default = Listen;
